<div class="row panel" style="position: relative; overflow: hidden;">
  <div class="card-block panel-body">
    <button type="button" class="btn btn-danger me-2"
            popover="Vivamus sagittis lacus vel augue laoreet rutrum faucibus.">
      Default popover
    </button>
    <button type="button" class="btn btn-success"
            popover="Vivamus sagittis lacus vel augue laoreet rutrum faucibus."
            container="body">
      Popover appended to body
    </button>
  </div>
</div>
